import { Badge, Stack } from '@qcx/ui';
import type { Editorial } from '@atreus/data';

export interface BadgesProps {
  items: Editorial[];
  badgesCount?: number;
}

export const Badges = ({ items, badgesCount = 2 }: BadgesProps) => {
  const badgesLength = items.length - badgesCount;
  const badges = items.slice(0, badgesCount);

  return (
    <Stack gap="$3">
      {badges.map(badge => (
        <Badge key={badge.slug} variant="primary">
          {badge.name}
        </Badge>
      ))}
      {badgesLength > 0 && <Badge variant="primary">+{badgesLength}</Badge>}
    </Stack>
  );
};
